export const withdrawalMethods = {
  STRIPE: 'STRIPE',
  VIRTUAL_CREDIT_CARD: 'VIRTUAL_CREDIT_CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
};

export const withdrawalMethodIcons = {
  [withdrawalMethods.STRIPE]: 'stripe',
  [withdrawalMethods.VIRTUAL_CREDIT_CARD]: 'credit-card',
  [withdrawalMethods.BANK_TRANSFER]: 'bank-transfer',
};

export const getAllAppliedPropertySlugs = (list, currentWithdrawalId) => {
  if (!list || list.length === 0) {
    return [];
  }
  const propertySlugs = [];
  list.forEach(withdrawal => {
    if (withdrawal.id !== currentWithdrawalId) {
      propertySlugs.push(...withdrawal.properties.map(p => p.slug));
    }
  });
  return propertySlugs;
};

/**
 * @param {object} payload
 * e.g.
 * {
 *   accountNumber: "2222"
 * }
 * @returns formatted value for api payload
 * Do not add params when value is undefined(for not required params)
 */
export const formatPayload = payload => {
  const formattedPayload = {};

  Object.keys(payload).forEach(param => {
    if (payload[param] || param === 'accountNumber') {
      formattedPayload[param] = payload[param].trim();
    } else if (payload[param] === '') {
      formattedPayload[param] = null;
    }
  });

  return formattedPayload;
};
